module.exports = __webpack_public_path__ + "static/media/logo.015834e9.png";